// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-detail-main-wrap{
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-top: 34px;
}

.invoice-booking-client{
    margin-left: 54px;
    margin-top: 37px;
}

.invoice-booking-client h3 {
    font-size: 26px;
    color: #1A1919;
    font-weight: 700;
    margin: 0px;
}


.booking-client-detail-wrap {
    display: flex;
    align-items: center;
    gap: 70px;
    margin-top: 18px;
}

.booking-client-detail p {
    font-size: 21px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
}

.booking-client-detail p span{
    /* color: #0F0FD5; */
    color:  #1E90FF;
}


.booking-client-detail p span:hover{
    color: #0F0FD5 
}

.send-mail-btn {
    width: 114px;
    height: 31px;
    background-color: #00A19B;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 12px;
}

.send-mail-btn p{
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    margin: 0px;
}

.send-mail-btn img {
    width: 14px;
}

.invoice-booking-industry-wrap h4 {
    font-size: 16px;
    color: #00A19B;
    font-weight: 500;
    margin: 0px;
}

.invoice-booking-industry-wrap {
    margin-top: 48px;
}

.invoice-address-left p {
    font-size: 14px;
    color: #1A1919;
    margin: 0px;
    font-weight: 400;
    min-width: 80px;
}

.invoice-address-right p {
    font-size: 14px;
    text-align: right;
    color: #626262;
    font-weight: 400;
    margin: 0px;
}


.invoice-address-reapet {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 10px;
}

.invoice-address-right{
    display: flex;
    align-items: center;
    gap: 2px;
}

p.right-border-line {
    border-right: 1px solid #ccc;
    padding-right: 10px;
}

.invoice-booking-detail-bottom-wrapper{
    margin-left: 56px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
}

.invoice-booking-detail-bottom-left{
    width: 44%;
}

.invoice-booking-detail-bottom-right{
    width: 48%;
}

.invoice-payout-wrap {
    width: 100%;
    height: 65px;
    background: #F5F5F5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 22px;
    margin-top: 16px;
}

.invoice-payout-wrap h3 {
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.invoice-payout-wrap p {
    font-size: 16px;
    color: #20CB00;
    font-weight: 600;
    margin: 0px;
}

.invoice-address-left {
    display: flex;
    align-items: center;
    gap: 6px;
}

.invoice-address-left img{
    cursor: pointer;
}

.invoice-address-left h4 {
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.invoice-address-right h4 {
    font-size: 16px;
    color: #00A19B;
    font-weight: 600;
    margin: 0px;
}

.booking-client-icon-wrap{
    display: flex;
    align-items: center;
    gap: 10px;
}

.booking-client-icon-wrap img{
  width: 20px;
  cursor: pointer;  
}

.invoce-status-btn-wrap {
    width: 232px;
    height: 70px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #00A19B;
}

.invoce-status-btn-wrap p {
    font-size: 22px;
    color: #F7F7F7;
    font-weight: 400;
    margin: 0px;
}



.invoice-status-wrapper h4 {
    font-size: 30px;
    color: #1A1919;
    font-weight: 500;
    margin: 0px;
    text-align: center;
    padding-bottom: 8px;
}

@media(max-width: 1024px){
    .invoce-status-btn-wrap {
      width: 150px;
      height: 55px;
    }

    .invoce-status-btn-wrap p {
        font-size: 16px;
    }

    .tx-status-wrapper-text h3 {
        text-align: center;
        margin-left: 0px !important;
        font-size: 20px;
    }

    .cleaner-payment-tx-wrap h3 {
        font-size: 18px !important;
    }

    .cleaner-payment-detail-left p {
        font-size: 18px !important;
    }

    .invoice-detail-main-wrap {
        align-items: flex-start;
    }

    .invoice-booking-client h3 {
        font-size: 22px;
    }

    .booking-client-detail p {
        font-size: 18px;
    }

    .booking-client-detail-wrap {
        flex-direction: column;
        gap: 50px;
        align-items: baseline;
        gap: 10px;
        margin-top: 18px;
    }

    .invoice-booking-industry-wrap {
        margin-top: 30px;
    }

    .invoice-booking-detail-bottom-wrapper {
        flex-direction: column;
        gap: 40px
    }

    .invoice-booking-detail-bottom-left {
        width: 100%;
    }

    .invoice-booking-detail-bottom-right {
        width: 100%;
    }

    .invoice-payout-wrap {
        width: 100%;
        height: 55px;
    }

    .transation-cart-item-wrap h4 {
        margin-bottom: 0px;
    }

    .booking-cart-items-wrap {
        margin-top: 14px;
    }

    .booking-cart-items-wrap.tracking-cart-item-wrap h5 {
        margin-top: 24px;
    }

    .transaction-status-btn-wrapper {
        flex-direction: column;
    }

    .transaction-status-btn-wrapper button {
        width: 150px;
        height: 55px;
    }

  }



@media(max-width: 767px){
    .invoice-detail-main-wrap {
        align-items: baseline;
        flex-direction: column;
        gap: 20px;
    }


    .after-before-image-wrap {
        flex-direction: column;
        gap: 20px;
    }

    .booking-cart-item-repeat {
        flex-direction: column;
        gap: 20px;
    }

    .booking-item-price-wrap p {
        min-width: unset;
    }

    .order-track-text-stat {
        font-size: 12px;
    }

    p.order-track-label {
        font-size: 12px;
    }

    .booking-cart-item-repeat > :first-child {
        align-self: flex-start;
    }
    
    .booking-cart-item-repeat > :last-child {
        align-self: flex-end;
    }

    .invoice-booking-client h3 {
        font-size: 18px;
    }

    .booking-client-detail p {
        font-size: 16px;
    }

    .invoice-booking-industry-wrap {
        margin-top: 10px;
    }

    .transaction-status-btn-wrapper {
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .transaction-status-btn-wrapper button {
        height: 56px;
    }

    .transaction-status-btn-wrapper button {
        width: 232px;
        height: 55px;
    }

}`, "",{"version":3,"sources":["webpack://./src/Dashboard/Invoices/invoice.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;;AAGA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;;;AAIA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;MACE,YAAY;MACZ,YAAY;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,2BAA2B;QAC3B,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,qBAAqB;QACrB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;EAEF;;;;AAIF;IACI;QACI,qBAAqB;QACrB,sBAAsB;QACtB,SAAS;IACb;;;IAGA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;AAEJ","sourcesContent":[".invoice-detail-main-wrap{\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    margin-top: 34px;\n}\n\n.invoice-booking-client{\n    margin-left: 54px;\n    margin-top: 37px;\n}\n\n.invoice-booking-client h3 {\n    font-size: 26px;\n    color: #1A1919;\n    font-weight: 700;\n    margin: 0px;\n}\n\n\n.booking-client-detail-wrap {\n    display: flex;\n    align-items: center;\n    gap: 70px;\n    margin-top: 18px;\n}\n\n.booking-client-detail p {\n    font-size: 21px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n}\n\n.booking-client-detail p span{\n    /* color: #0F0FD5; */\n    color:  #1E90FF;\n}\n\n\n.booking-client-detail p span:hover{\n    color: #0F0FD5 \n}\n\n.send-mail-btn {\n    width: 114px;\n    height: 31px;\n    background-color: #00A19B;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 12px;\n}\n\n.send-mail-btn p{\n    font-size: 14px;\n    color: #fff;\n    font-weight: 400;\n    margin: 0px;\n}\n\n.send-mail-btn img {\n    width: 14px;\n}\n\n.invoice-booking-industry-wrap h4 {\n    font-size: 16px;\n    color: #00A19B;\n    font-weight: 500;\n    margin: 0px;\n}\n\n.invoice-booking-industry-wrap {\n    margin-top: 48px;\n}\n\n.invoice-address-left p {\n    font-size: 14px;\n    color: #1A1919;\n    margin: 0px;\n    font-weight: 400;\n    min-width: 80px;\n}\n\n.invoice-address-right p {\n    font-size: 14px;\n    text-align: right;\n    color: #626262;\n    font-weight: 400;\n    margin: 0px;\n}\n\n\n.invoice-address-reapet {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 10px;\n}\n\n.invoice-address-right{\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\np.right-border-line {\n    border-right: 1px solid #ccc;\n    padding-right: 10px;\n}\n\n.invoice-booking-detail-bottom-wrapper{\n    margin-left: 56px;\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 40px;\n}\n\n.invoice-booking-detail-bottom-left{\n    width: 44%;\n}\n\n.invoice-booking-detail-bottom-right{\n    width: 48%;\n}\n\n.invoice-payout-wrap {\n    width: 100%;\n    height: 65px;\n    background: #F5F5F5;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 22px;\n    margin-top: 16px;\n}\n\n.invoice-payout-wrap h3 {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.invoice-payout-wrap p {\n    font-size: 16px;\n    color: #20CB00;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.invoice-address-left {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.invoice-address-left img{\n    cursor: pointer;\n}\n\n.invoice-address-left h4 {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.invoice-address-right h4 {\n    font-size: 16px;\n    color: #00A19B;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.booking-client-icon-wrap{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.booking-client-icon-wrap img{\n  width: 20px;\n  cursor: pointer;  \n}\n\n.invoce-status-btn-wrap {\n    width: 232px;\n    height: 70px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #00A19B;\n}\n\n.invoce-status-btn-wrap p {\n    font-size: 22px;\n    color: #F7F7F7;\n    font-weight: 400;\n    margin: 0px;\n}\n\n\n\n.invoice-status-wrapper h4 {\n    font-size: 30px;\n    color: #1A1919;\n    font-weight: 500;\n    margin: 0px;\n    text-align: center;\n    padding-bottom: 8px;\n}\n\n@media(max-width: 1024px){\n    .invoce-status-btn-wrap {\n      width: 150px;\n      height: 55px;\n    }\n\n    .invoce-status-btn-wrap p {\n        font-size: 16px;\n    }\n\n    .tx-status-wrapper-text h3 {\n        text-align: center;\n        margin-left: 0px !important;\n        font-size: 20px;\n    }\n\n    .cleaner-payment-tx-wrap h3 {\n        font-size: 18px !important;\n    }\n\n    .cleaner-payment-detail-left p {\n        font-size: 18px !important;\n    }\n\n    .invoice-detail-main-wrap {\n        align-items: flex-start;\n    }\n\n    .invoice-booking-client h3 {\n        font-size: 22px;\n    }\n\n    .booking-client-detail p {\n        font-size: 18px;\n    }\n\n    .booking-client-detail-wrap {\n        flex-direction: column;\n        gap: 50px;\n        align-items: baseline;\n        gap: 10px;\n        margin-top: 18px;\n    }\n\n    .invoice-booking-industry-wrap {\n        margin-top: 30px;\n    }\n\n    .invoice-booking-detail-bottom-wrapper {\n        flex-direction: column;\n        gap: 40px\n    }\n\n    .invoice-booking-detail-bottom-left {\n        width: 100%;\n    }\n\n    .invoice-booking-detail-bottom-right {\n        width: 100%;\n    }\n\n    .invoice-payout-wrap {\n        width: 100%;\n        height: 55px;\n    }\n\n    .transation-cart-item-wrap h4 {\n        margin-bottom: 0px;\n    }\n\n    .booking-cart-items-wrap {\n        margin-top: 14px;\n    }\n\n    .booking-cart-items-wrap.tracking-cart-item-wrap h5 {\n        margin-top: 24px;\n    }\n\n    .transaction-status-btn-wrapper {\n        flex-direction: column;\n    }\n\n    .transaction-status-btn-wrapper button {\n        width: 150px;\n        height: 55px;\n    }\n\n  }\n\n\n\n@media(max-width: 767px){\n    .invoice-detail-main-wrap {\n        align-items: baseline;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n\n    .after-before-image-wrap {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .booking-cart-item-repeat {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .booking-item-price-wrap p {\n        min-width: unset;\n    }\n\n    .order-track-text-stat {\n        font-size: 12px;\n    }\n\n    p.order-track-label {\n        font-size: 12px;\n    }\n\n    .booking-cart-item-repeat > :first-child {\n        align-self: flex-start;\n    }\n    \n    .booking-cart-item-repeat > :last-child {\n        align-self: flex-end;\n    }\n\n    .invoice-booking-client h3 {\n        font-size: 18px;\n    }\n\n    .booking-client-detail p {\n        font-size: 16px;\n    }\n\n    .invoice-booking-industry-wrap {\n        margin-top: 10px;\n    }\n\n    .transaction-status-btn-wrapper {\n        flex-direction: column;\n        align-items: center;\n        gap: 20px;\n    }\n\n    .transaction-status-btn-wrapper button {\n        height: 56px;\n    }\n\n    .transaction-status-btn-wrapper button {\n        width: 232px;\n        height: 55px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
